import ModelUtil from '@leverege/model-util';
import isEqual from 'fast-deep-equal';

/**
 * This is very similar to the Molten Table Filter Model
 * but I'm not sure how I could use that directly without causing
 * a dependency cycle, so I made a specific one here.
 */

const TYPE = 'rsrc';
function create(extend) {
  const objRef = extend || {};
  const {
    data: obj = {}
  } = objRef;
  const {
    data,
    metadata,
    ...rest
  } = obj;
  let metadataJSON = null;
  try {
    metadataJSON = JSON.stringify(metadata, null, 2);
  } catch (error) {
    console.error(error, metadata);
  }
  return {
    type: TYPE,
    id: extend.id || null,
    ref: extend.ref || null,
    data: {
      ...rest,
      data: data || null,
      metadata: metadata || null,
      metadataJSON
    }
  };
}
function toObjRef(model) {
  const nModel = {
    ...model
  };
  if (nModel?.data?.metadataJSON) {
    let parsed;
    try {
      parsed = JSON.parse(nModel.data.metadataJSON);
      if (!isEqual(nModel.data.metadata, parsed)) {
        nModel.data.metadata = parsed;
      }
    } catch (err) {}
    delete nModel.data.metadataJSON;
  }
  return nModel;
}
const getDetails = ModelUtil.createGetValue('data/details');
const shared = {
  ...ModelUtil.createAllValue('data/type', 'rsrcType'),
  ...ModelUtil.createAllValue('data/path', 'path'),
  ...ModelUtil.createAllValue('data/data', 'data'),
  ...ModelUtil.createAllValue('data/metadata', 'metadata'),
  ...ModelUtil.createAllValue('data/metadataJSON', 'metadataJSON')
};
export default {
  TYPE,
  create,
  getId: ModelUtil.createGetValue('id'),
  getRef: ModelUtil.createGetValue('ref'),
  getRootData: ModelUtil.createGetValue('data'),
  ...shared,
  getProjectId: ModelUtil.createGetValue('data/projectId'),
  getOwnerId: ModelUtil.createGetValue('data/ownerId'),
  getCoownerId: ModelUtil.createGetValue('data/coownerId'),
  getCreatedAt: ModelUtil.createGetValue('data/createdAt'),
  getUpdatedAt: ModelUtil.createGetValue('data/updatedAt'),
  getDetails,
  hasDetails: model => getDetails(model) != null,
  toObjRef
};